module.exports = __webpack_public_path__ + "assets/cover_0.jpg";


/*****************
 ** WEBPACK FOOTER
 ** ./assets/cover_0.jpg
 ** module id = 108
 ** module chunks = 1
 **/